import type { KeyPress, ShortcutScope } from '@sunucupark/client-core';
import { useCallback } from 'react';
import { useClient } from './client-context';

/**
 * Turns a key press into the action it means in the scopes currently on screen.
 * The listener itself belongs to the app (the DOM is not ours), the decision does not.
 */
export function useShortcutHandler(
  scopes: readonly ShortcutScope[],
  run: (id: string) => void,
): (press: KeyPress) => boolean {
  const { shortcuts } = useClient();
  return useCallback(
    (press: KeyPress) => {
      const match = shortcuts.handle(press, scopes);
      if (match.type === 'match') {
        run(match.id);
        return true;
      }
      // A pending sequence still swallows the key, so "g" does not type into the page.
      return match.type === 'pending';
    },
    [shortcuts, scopes, run],
  );
}
